import * as React from 'react';
import * as classNames from 'classnames';
import { ComposerEditingMode } from '../../clipbook/types';

export enum TopToolbarMode {
  OKCancel,
  Editing,
}

interface TopToolbarProps {
  mode: TopToolbarMode;
  editingMode: ComposerEditingMode;
  caption: string;
  canZoomIn: boolean;
  canZoomOut: boolean;
  canResetZoom: boolean;
  canGoPrev: boolean;
  canGoNext: boolean;
  onClickOK: () => void;
  onClickCancel: () => void;
  onClickZoomAndPan: () => void;
  onClickDrawing: () => void;
  onClickZoomIn: () => void;
  onClickZoomOut: () => void;
  onClickResetZoom: () => void;
  onClickPrev: () => void;
  onClickNext: () => void;
  onClickNewPage: () => void;
  onClickBackToViewer: () => void;
}

export default class TopToolbar extends React.Component<TopToolbarProps> {
  private handleClickZoomIn = () => {
    if (this.props.canZoomIn) {
      this.props.onClickZoomIn();
    }
  }

  private handleClickZoomOut = () => {
    if (this.props.canZoomOut) {
      this.props.onClickZoomOut();
    }
  }

  private handleClickResetZoom = () => {
    if (this.props.canResetZoom) {
      this.props.onClickResetZoom();
    }
  }

  private handleClickPrev = () => {
    if (this.props.canGoPrev) {
      this.props.onClickPrev();
    }
  }

  private handleClickNext = () => {
    if (this.props.canGoNext) {
      this.props.onClickNext();
    }
  }

  public render() {
    const activeStyle = { color: '#f60' };
    const displayNone = { display: 'none' };
    return (
      <div className="mdc-toolbar mdc-toolbar--fixed">
        <div className="mdc-toolbar__row">
          <section className="mdc-toolbar__section mdc-toolbar__section--align-start">
            <span className="mdc-toolbar__title">{this.props.caption}</span>
          </section>
          <section className="mdc-toolbar__section mdc-toolbar__section--align-end">
            <span style={this.props.mode === TopToolbarMode.Editing ? {} : displayNone}>
              <a onClick={this.props.onClickZoomAndPan}
                style={this.props.editingMode === ComposerEditingMode.ZoomAndPan ? activeStyle : {}}
                className="material-icons mdc-toolbar__icon"
                title="ズーム/パン"
                aria-label="Zoom/Pan">
                zoom_out_map
              </a>
              <a onClick={this.props.onClickDrawing}
                style={this.props.editingMode === ComposerEditingMode.Drawing ? activeStyle : {}}
                className="material-icons mdc-toolbar__icon"
                title="お絵かき"
                aria-label="Drawing">
                image
              </a>
            </span>
          </section>
          <section style={{ flexGrow: 2 }}
            className="mdc-toolbar__section mdc-toolbar__section--align-end">
            <span style={this.props.mode === TopToolbarMode.Editing ? {} : displayNone}>
              <a onClick={this.handleClickZoomIn}
                className={classNames(
                  'material-icons mdc-toolbar__icon', { disabled: !this.props.canZoomIn },
                )}
                title="拡大"
                aria-label="Zoom in">
                zoom_in
              </a>
              <a onClick={this.handleClickZoomOut}
                className={classNames(
                  'material-icons mdc-toolbar__icon', { disabled: !this.props.canZoomOut },
                )}
                title="縮小"
                aria-label="Zoom out">
                zoom_out
              </a>
              <a onClick={this.handleClickResetZoom}
                className={classNames(
                  'material-icons mdc-toolbar__icon', { disabled: !this.props.canResetZoom },
                )}
                title="拡大縮小をリセット"
                aria-label="Reset zoom">
                aspect_ratio
              </a>
              <a onClick={this.handleClickPrev}
                className={
                  classNames('material-icons mdc-toolbar__icon', {
                    disabled: !this.props.canGoPrev,
                  })
                }
                title="前のノートへ"
                aria-label="Prev">
                navigate_before
              </a>
              <a onClick={this.handleClickNext}
                className={
                  classNames('material-icons mdc-toolbar__icon', {
                    disabled: !this.props.canGoNext,
                  })
                }
                title="次のノートへ"
                aria-label="Next">
                navigate_next
              </a>
              <a onClick={this.props.onClickNewPage}
                className="material-icons mdc-toolbar__icon"
                title="新しいノート"
                aria-label="New Note">
                add_box
              </a>
              <a onClick={this.props.onClickBackToViewer}
                className="material-icons mdc-toolbar__icon"
                title="ビューアへ戻る"
                aria-label="Back To Viewer">
                arrow_back
              </a>
            </span>
            <span style={this.props.mode === TopToolbarMode.OKCancel ? {} : displayNone}>
              <a onClick={this.props.onClickOK}
                className="material-icons mdc-toolbar__icon"
                title="OK"
                aria-label="OK">
                check
              </a>
              <a onClick={this.props.onClickCancel}
                className="material-icons mdc-toolbar__icon"
                title="キャンセル"
                aria-label="Cancel">
                close
              </a>
            </span>
          </section>
        </div>
      </div>
    );
  }
}
